import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import {
    TAnnex6V2BackendRecord,
} from '../../../../../redux/app/annex6-v2/@types';
import { IStore } from '../../../../../redux/store';
import Annex6V2Previewer from './Annex6V2Previewer';
import Annex6V2RecordParticipantsView from '../new-operation/_elements_v2/ParticipantsView';
import Annex6V2AttachmentPrintView from '../new-operation/_elements_v2/Annex6V2AttachmentPrintView';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    annex6V2Records: TAnnex6V2BackendRecord[];
    isPrintVisible: boolean;
    showShipInfo?: boolean;
	vesselId: string;
};
type Annex6V2PrintProps = OwnProps & PropsFromRedux;
function Annex6V2Print(props: Annex6V2PrintProps) {
    const {
        isPrintVisible,
        annex6V2Records,
        showShipInfo = false,
        vesselName,
        imoNumber,
    } = props;
    if (!isPrintVisible) return null;
    return (
        <div className="w-full p-12">
            <div className="mb-8">
                <h3 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
                    Annex VI Operations
                </h3>
            </div>
            {showShipInfo ? (
                <>
                    <ol className="ml-4 list-alpha" start={9}>
                        <li className="mb-2">
                            <b>
                                Additional operational procedures and general
                                remarks
                            </b>
                        </li>
                    </ol>
                    <div className="flex flex-col ">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 text-sm min-w-fit">
                                Name of ship
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                {vesselName}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 text-sm min-w-fit">
                                IMO Number
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                {imoNumber}
                            </p>
                        </div>
                    </div>
                </>
            ) : null}

            <div className="w-full bg-gray-100">
                <table className="w-full bg-gray-100 marpol-table annex6-table h-full">
                    <thead className="h-full">
                        <tr className="bg-gray-100 h-full">
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-28 h-full flex justify-center items-center">
                                    Date
                                </div>
                            </th>
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20 h-full flex flex-col justify-center items-center">
                                    <p style={{ margin: 0 }}>Code</p>
                                    <p style={{ margin: 0 }} className="m-0">
                                        (Letter)
                                    </p>
                                </div>
                            </th>
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-right text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20 h-full flex flex-col justify-center items-center">
                                    <p style={{ margin: 0 }}>Item</p>
                                    <p style={{ margin: 0 }} className="m-0">
                                        (number)
                                    </p>
                                </div>
                            </th>
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20 h-full flex justify-center items-center">
                                    Record of operations/signature of officer in
                                    charge
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {annex6V2Records.map((annex6V2Record, index) => {
                            const isSubmitterChiefOrMaster =
                                annex6V2Record.approvedBy
                                    ? annex6V2Record.approvedBy.staffId ===
                                      annex6V2Record.submittedBy?.staffId
                                    : false;
                            return (
                                <React.Fragment key={annex6V2Record.id}>
                                    <Annex6V2Previewer
                                        annex6V2Record={annex6V2Record}
                                        theme="light"
                                    />
                                    <Annex6V2RecordParticipantsView
                                        isSubmitterChiefOrMaster={
                                            isSubmitterChiefOrMaster
                                        }
                                        annex6V2Record={annex6V2Record}
                                        theme="light"
                                    />
                                    <Annex6V2AttachmentPrintView
                                        annex6V2Record={annex6V2Record}
                                    ></Annex6V2AttachmentPrintView>
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        vesselName: vesselInfo?.vesselName,
        imoNumber: vesselInfo?.imoNumber,
    };
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Annex6V2Print);
